import { Toggle } from './styles'

const Component = ({onClick, children, ...rest}:any) =>{
  return <Toggle onClick={onClick} {...rest}>{children}</Toggle>
}

export default Component
